import React from 'react';
import { useSelector } from "react-redux";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms,UserRoleEnum } from "../../../../helpers/enums";

import './VerificaDellaPressioneCase.scss';

const VerificaDellaPressioneCase = () => {
  const user = useSelector((state) => state.auth);
  const profile = user.impersonationActive ? user.profileImpersonate : user.profile;
  return (
    <div
      className="VerificaDellaPressioneCase"
      data-testid="VerificaDellaPressioneCase"
    >
      <CaseGenerator
        type={CaseForms.VerificaDellaPressione}
        initialValues={
          {...profile,
           ...((profile.role === UserRoleEnum.PRIVATE || profile.businessName==='') && { businessName: `${profile.name} ${profile.surname}` }),
          }
         }
      />
    </div>
  );
};
export default VerificaDellaPressioneCase;
